module.exports = __webpack_public_path__ + "img/Kaleh_logo.c05cea49.png";